import { render, staticRenderFns } from "./CardActivities.vue?vue&type=template&id=2b71b036&"
import script from "./CardActivities.vue?vue&type=script&lang=js&"
export * from "./CardActivities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports